import MessageIcon from '@material-ui/icons/Message';
import { CompanyNotificationCreateView } from './views/company-notification-create.view';

export default {
  create: CompanyNotificationCreateView,
  icon: MessageIcon,
};
